const NAME_ICON_MAP = {
  企业官网: 'building',
  电商平台: 'cart',
  产品展示: 'sparkle',
}

export function getProjectIconKey(project) {
  if (!project) return 'building'
  if (project.icon && ['building', 'cart', 'sparkle'].includes(project.icon)) {
    return project.icon
  }
  return NAME_ICON_MAP[project.name] || 'building'
}

export function translateProject(project, t) {
  if (!project) return { name: '', description: '' }
  const key = getProjectIconKey(project)
  return {
    ...project,
    name: t(`projectItems.${key}.name`),
    description: t(`projectItems.${key}.desc`),
  }
}

export function localizedContact(apiContact, locale, t) {
  const data = apiContact || {}
  return {
    email: data.email || t('contact.defaultEmail'),
    phone: data.phone || t('contact.defaultPhone'),
    address: data.address || t('contact.defaultAddress'),
    work_hours: data.work_hours || t('contact.defaultWorkHours'),
  }
}

export const APPOINTMENT_SLOT_KEYS = [
  'slot1', 'slot2', 'slot3', 'slot4', 'slot5', 'slot6',
]

export function getAppointmentSlots(t) {
  return APPOINTMENT_SLOT_KEYS.map((key) => ({
    key,
    label: t(`appointment.${key}`),
  }))
}
